<template>
  <section class="high-efficiency-flash-black">
    <div class="flash-black-phone-trans"></div>
    <div class="high-efficiency-flash-black-sticky">
      <div class="flash-black-container">
        <div v-if="!vm.isMobile" ref="phonePlaceholder" class="flash-black-phone-placeholder">
          <img
            v-lazy="
              require(lang === 'zh'
                ? '../../assets/zh/highEfficiency/flashback-phone.png'
                : '../../assets/privacy/seperation-mobile-phone-1.png')
            "
            alt="ColorOS 11"
            class="flash-black-phone-img"
          />
          <div class="flash-black-phone-content" :style="phoneStyle">
            <img
              :src="
                require(`../../assets/${lang === 'zh' ? 'zh/' : ''}highEfficiency/flash-black-video-background.jpg`)
              "
              class="flash-black-video-background"
              :class="progress >= 0.864 ? 'flash-black-video-background-show' : ''"
            />
            <video ref="phonePCVideo" muted="muted" preload="meta" loop>
              <source
                :src="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}highEfficiency/flash-back-video.webm`)"
                type="video/webm"
              />
              <source
                :src="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}highEfficiency/flash-back-video.mp4`)"
                type="video/mp4"
              />
            </video>
            <div v-if="progress >= 0.99" class="flash-black-phone-top"></div>
          </div>
        </div>
        <div
          v-if="vm.isMobile"
          ref="phonePlaceholder"
          class="flash-black-phone-placeholder wow textInPartMotion flash-black-phone-mobile"
          :class="{
            'flash-black-phone-svg-hide': videoPlaying,
            'flash-black-phone-svg-black': videoHasNotPlaying
          }"
          data-wow-duration=".7s"
          data-wow-delay="0.3s"
          data-wow-offset="100"
        >
          <lazy-component ref="phoneVideoMobile" style="height: 100%; font-size: 0px;" @show="videoShow">
            <video
              :src="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}highEfficiency/flash-black-phone.mp4`)"
              class="flash-black-phone-img"
              :poster="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}highEfficiency/flash-black-phone-poster.jpg`)"
              muted="true"
              preload="meta"
              x5-playsinline
              webkit-playsinline
              playsinline
              x5-video-player-type="h5"
              x5-video-orientation="portraint"
            ></video>
            <img
              :src="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}highEfficiency/flash-black-phone-poster.jpg`)"
              style="transform: scale(1, 0.996)"
              alt="ColorOS 11"
            />
          </lazy-component>
          <play-button-text ref="playButtonText" target-video=".flash-black-phone-mobile video" />
        </div>
        <div
          ref="text"
          v-textMotion="vm.isMobile ? 100 : 200"
          class="text-intro flash-black-text-intro"
          :class="lang === 'zh' ? 'flash-black-text-intro-zh' : ''"
        >
          <p class="title">{{ $t('flash-black-title') }}</p>
          <p class="sub-title">{{ $t('flash-black-sub-title') }}</p>
          <p class="description">{{ $t('flash-black-description') }}<sup v-if="lang !== 'zh'">4</sup></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';
import PlayButtonText from '@/components/PlayButtonText';

export default {
  inject: ['vm', 'lang'],
  components: {
    PlayButtonText
  },
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      progress: 0,
      initScaleRate: 20,
      centerTransformX: 0,
      imgWidth: '795px',
      videoPlaying: false,
      videoHasNotPlaying: true
    };
  },
  computed: {
    phoneStyle() {
      let progress = Math.max(0, (this.progress - 0.16) / 0.84);
      progress = progress < 0.85 ? 1.15 * progress : progress * (2 - progress);
      // const transformOriginX = 27.5 - (1920 / window.innerWidth - 1) * 13.5;
      // const transformOriginY = 22 - (1920 / window.innerWidth - 1) * 5;
      const baseTransY = -170;
      return {
        transform: `translate(${this.centerTransformX * (1 - Math.max(0, (progress - 0.5) / 0.5))}px, ${baseTransY +
          progress * 15}vh) scale(${this.initScaleRate - progress * (this.initScaleRate - 1)})`,
        // height: 473 - (473 - 356) * progress + 'px',
        borderRadius: 12 * progress + 'px',
        filter: progress >= 0.99 ? 'drop-shadow(0px 6px 4px rgba(0, 0, 0, 0.14))' : ''
        // transformOrigin: `${transformOriginX}% ${this.lang === 'zh' ? transformOriginY : '14'}%`
      };
    }
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      let protectDuration = +new Date();
      this.scene = new ScrollMagic.Scene({
        duration: 1.5 * window.innerHeight,
        triggerElement: '.flash-black-phone-trans',
        triggerHook: 0
        // offset: 0.5 * window.innerHeight
      })
        .setPin('.flash-black-phone-content')
        .addTo(Controller)
        .on('progress', e => {
          // this.updateBezier('progress', e.progress, 100);
          this.progress = e.progress;
          // this.progress = e.progress;
          if (e.progress === 1) {
            if (this.$refs.phonePCVideo) {
              this.$refs.phonePCVideo.pause();
              this.videoPCPlayed = false;
            }
          }
        });

      this.videoPCScene = new ScrollMagic.Scene({
        triggerElement: '.flash-black-phone-trans',
        triggerHook: 0
      })
        .addTo(Controller)
        .on('enter', () => {
          const delta = +new Date() - protectDuration;
          setTimeout(
            () => {
              if (this.progress >= 0 && this.progress !== 1) {
                if (this.videoPCPlayed) return;
                this.videoPCPlayed = true;
                this.handleVideoPCPlay();
              }
            },
            delta > 1000 ? 0 : 1000 - delta
          );
        });

      // 最下面的时候 scrollmagic 初始化失败，一直是0，不是1，所以假设一开始进度是1，如果是0的话，会马上触发切回0
      this.scene.progress(1);
    },
    resizeHandler() {
      const imgWidth = this.$refs.phonePlaceholder.clientWidth;
      const imgHeight = 120.9;
      // 根据屏幕动态确定scale比例
      const withRate = ((window.innerWidth - 15) / imgWidth) * (322 / 215) + 0.4;
      const heightRate = window.innerHeight / imgHeight + 2;

      this.initScaleRate = Math.max(withRate, heightRate);
      // 右边词条问题，初始化化长度不对
      const textDelta = this.$refs.text.clientHeight < 150 ? (587 - this.$refs.text.clientWidth) / 2 : 0;
      this.centerTransformX =
        (window.innerWidth - 15) / 2 - 321 / 2 - this.$refs.phonePlaceholder.getBoundingClientRect().left + textDelta;

      if (this.vm.isMobile) {
        this.initScaleRate = 1;
        this.progress = 2;
        if (this.scene) {
          this.scene.destroy(true);
          this.scene = null;
          this.videoPCScene.destroy(true);
          this.videoPCScene = null;
        }
      } else if (!this.vm.isMobile && !this.scene) {
        this.initScroll();
      }
      // 防止高度变化导致的裁切问题
      if (this.scene) this.scene.duration(1.5 * window.innerHeight);
    },
    videoShow() {
      setTimeout(() => {
        if (this.$refs.phoneVideoMobile.$el && this.$refs.phoneVideoMobile.$el.children) {
          this.$refs.playButtonText.init();
          this.$refs.phoneVideoMobile.$el.children[0].addEventListener('ended', () => {
            this.videoPlaying = false;
          });
        } else {
          this.videoShow();
        }
      }, 100);
    },
    handleVideoPCPlay() {
      setTimeout(() => {
        if (this.$refs.phonePCVideo) {
          this.$refs.phonePCVideo.play();
        } else {
          this.handleVideoPCPlay();
        }
      }, 10);
    },
    handleVideoMobilePlay() {
      if (!(this.$refs.phoneVideoMobile.$el && this.$refs.phoneVideoMobile.$el.children)) return;
      this.$refs.phoneVideoMobile.$el.children[0].currentTime = 0;
      this.$refs.phoneVideoMobile.$el.children[0].play();
      this.videoPlaying = true;
      this.videoHasNotPlaying = false;
    }
  }
};
</script>
